export default __webpack_public_path__ + "static/CommunityBenefitsAgreementsCBAs-2dc4f8d7bf33233076deb7116ca4163f.jpg";